import { IMessageBroker } from "@sparkware/uc-sdk-core";
import { MB_HEADERS } from "../externalCommunication";

export function publishAuthenticationFailed(messageBroker: IMessageBroker) {
  messageBroker.identity.topics.userAuthenticationFailed.publish(
    MB_HEADERS,
    {}
  ); // TODO: add payload?
}
